<template>
  <v-container fluid class="px-0">
    <v-card outlined class="my-0">
      <v-card-title style="padding: 0.5rem 1rem">
        <v-row @click="setExpanded" style="cursor: pointer" no-gutters>
          <v-col cols="4"
            ><v-icon>{{
              isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
            }}</v-icon>
            {{ $t('Filtras') }}</v-col
          >
        </v-row>
      </v-card-title>
      <v-expand-transition>
        <v-card-text class="pt-1" v-if="isExpanded">
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-0 pb-0">
              <v-col cols="12" md="6">
                <el-text-field
                  label="Identifikavimo kodas"
                  tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Mano dokumentai. Identifikavimo kodas"
                  v-model="mainData['mandate_code-search-like']"
                  hide-details
                  :maxlength="1000"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="Įgaliotojas / JA, išdavęs prokūrą"
                  tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Mano dokumentai. Įgaliotojas"
                  v-model="mainData['principals-search-custom']"
                  hide-details
                  :maxlength="1000"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="Įgaliotinis / prokuristas"
                  tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Mano dokumentai. Įgaliototinis"
                  v-model="mainData['representitives-search-custom']"
                  hide-details
                  :maxlength="1000"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-autocomplete
                  :items="enumsClassifiers.journalType"
                  enums
                  hide-details
                  itemvalue="value"
                  itemtext="text"
                  label="Būsena"
                  tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Mano dokumentai. Būsena"
                  v-model="mainData['status-search-custom']"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-autocomplete
                  :items="enumsClassifiers.inJournalTypeSearch"
                  enums
                  hide-details
                  itemvalue="value"
                  itemtext="text"
                  label="Dokumento tipas"
                  tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Mano dokumentai. Dokumento tipas"
                  v-model="mainData['in_journal_type-search-like']"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-autocomplete
                  :items="enumsClassifiers.mandateKind"
                  enums
                  hide-details
                  itemvalue="value"
                  itemtext="text"
                  label="Įgaliojimo rūšis"
                  tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Mano dokumentai. Įgaliojimo rūšis"
                  v-model="mainData['type-search-custom']"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-date-picker
                  label="Būsenos data nuo"
                  tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Mano dokumentai. Būsenos data nuo"
                  v-model="mainData['registration_date_from-search-custom']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-date-picker
                  label="Būsenos data iki"
                  tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Mano dokumentai. Būsenos data iki"
                  v-model="mainData['registration_date_to-search-custom']"
                  hide-details
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <el-button
                  class="mr-1"
                  title="Ieškoti"
                  :loading="loading"
                  color="primary"
                  icon="ieškoti"
                  @click.native.stop="searchData(true)"
                />
                <el-button
                  color="secondary"
                  icon="išvalyti"
                  title="Išvalyti"
                  :loading="loading"
                  @click.native="clearData()"
                />
              </v-col>
            </v-row>
          </form>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Enums from '@/enums'

export default {
  name: 'DocumentsSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    mainData: {},
    enumsClassifiers: [],
  }),
  computed: {
    ...mapGetters(['searchParams']),
    isExpanded() {
      if (this.mainData.isExpanded == null) {
        this.$set(this.mainData, 'isExpanded', false)
      }
      return this.mainData.isExpanded
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getClassifiers()
    this.searchData()
  },
  methods: {
    setExpanded() {
      let logic = !this.mainData.isExpanded
      this.$set(this.mainData, 'isExpanded', logic)
    },
    getClassifiers() {
      this.enumsClassifiers = Enums
      if (this.searchParams && this.searchParams.route === this.$route.name) {
        this.mainData = this.searchParams.mainData
      }
    },
    searchData(button) {
      let searchData = { ...this.mainData }
      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
      })
      searchData.btn = button
      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {isExpanded: true, clear: true }
      this.$nextTick(() => {
        this.mainData = { isExpanded: true }
        this.searchData(true)
      })
    },
    submit() {
      this.searchData(true)
    },
  },
}
</script>
